import { useEffect, useRef, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import AtkTextField from "../AtlaskitControls/AtkTextField";
import AtkLoader from "../AtlaskitControls/AtkLoader";
import CommonValues from "../common/utils";
import axios from "axios";
import { Toast } from "primereact/toast";
import _ from "lodash";
import SupportLoader from "../common/SupportLoader";
import moment from "moment";
import P_Icon from "../assets/images/P_Icon.png";
import I_Icon from "../assets/images/I_Icon.png";
import { InputSwitch } from "primereact/inputswitch";

export default function ClientPolicyStep(props: any) {
  const navigate = useNavigate();
  const toast: any = useRef("");

  const [loading, setLoading] = useState(false);
  const [searchClientList, setSearchClientList] = useState<any>([]);
  const [searchClientLoading, setSearchClientLoading] = useState(true);

  const debouncedFetchResults = useCallback(
    _.debounce((searchQuery: any) => {
      getNowCertsClients(searchQuery);
    }, 500),
    []
  );

  useEffect(() => {
    if (props.search.replaceAll(" ", "") == "") {
      return;
    }
    setSearchClientLoading(true);
    if (props.search) {
      debouncedFetchResults(props.search);
    }
    return () => {
      debouncedFetchResults.cancel();
    };
  }, [props.search, debouncedFetchResults]);
  const getNowCertsClients = (query: string) => {
    var data = {
      SearchValue: query,
    };
    let nowCertsToken = localStorage.getItem("NCToken") ? localStorage.getItem("NCToken") : "";
    var config = {
      method: "GET",
      url: `${process.env.REACT_APP_NOWCERTSAPI}/api/nowcert/customerlist?searchText=${query}&nowCertsToken=${nowCertsToken}`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("igtoken")}`,
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(config)
      .then((response) => {
        setSearchClientList(response.data);
        setSearchClientLoading(false);
      })
      .catch((error) => {
        let errorMessage = "";
        if (error.response != null) {
          if (error.response.status === 401) {
            CommonValues.Logout(navigate);
          } else {
            toast.current.show({
              severity: "error",
              summary: "Error",
              detail: "Unknown error while loading the insureds data.Please try again later.",
              life: 3000,
            });
          }
        }
        setSearchClientLoading(false);
      });
  };
  const onClientSearchChange = (value: any) => {
    if (value.length > 255) {
      return;
    }
    props.setSearch(value);
  };

  return (
    <div className="card border-0">
      <Toast ref={toast} />
      <div className=" border-bottom pb-3 px-4 pt-4">
        <h6 className="mb-1">Client & Quote</h6>
        <p className="text-muted mb-0 text-12">Select client and quote</p>
      </div>

      <div className="card-body pt-4 px-4">
        <div className="row mx-auto">
          <div className="col-4 position-relative p-0">
            <div className="mb-4">
              <label htmlFor="file-upload" className="form-label fw-medium text-14">
                Select Client/Prospect <span className="text-danger"> *</span>
              </label>
              <div className="search-bar ">
                <AtkTextField
                  type="text"
                  id="text"
                  className="search-area "
                  name="clientName"
                  onChange={(e) => {
                    onClientSearchChange(e.target.value);
                  }}
                  value={props.search}
                  placeholder={props.clientName.length > 0 ? props.clientName : "Enter client/Prospect name"}
                />
              </div>
              {props.search.replaceAll(" ", "").length > 0 && (
                <div id="client-search" className="position-absolute">
                  {searchClientLoading ? (
                    <div className="d-flex justify-content-center my-2 client-loader-div">
                      <AtkLoader />
                    </div>
                  ) : searchClientList.length === 0 ? (
                    <div style={{ padding: "5px", background: "white" }}>
                      <span style={{ color: "#ddd", marginLeft: "10px" }}>No results found</span>
                    </div>
                  ) : (
                    searchClientList.map((item: any, index: number) => (
                      <div
                        key={index}
                        style={{ cursor: "pointer", width: "100%" }}
                        onClick={() => {
                          props.onClientSelect(item);
                        }}
                      >
                        <a
                          href="#"
                          style={{
                            color: "black",
                            width: "100%",
                            fontSize: "12px",
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                            padding: "4px 8px",
                            backgroundColor: "#fff",
                          }}
                        >
                          <img
                            src={item.insuredType === 0 ? I_Icon : P_Icon}
                            alt={item.insuredType === 0 ? "I" : "P"}
                            style={{ width: "16px", height: "16px" }}
                          />
                          {item.name}
                        </a>
                      </div>
                    ))
                  )}
                </div>
              )}
            </div>
          </div>
          <div className="col-5 d-flex  mb-2 gap-3">
            <div className="d-flex flex-column">
              <label className="form-label fw-medium text-14">Select a Quote from AMS</label>
              <InputSwitch checked={props.isQuoteSelected} onChange={props.onQuoteChange} />
            </div>

            <div className="d-flex flex-column">
              <label className="form-label fw-medium text-14">Upload a Quote Letter</label>
              <InputSwitch checked={props.isDocumentSelected} onChange={props.onDocumentChange} />
            </div>
          </div>
        </div>
        {props.nowcertsPolicyLoading ? (
          <div className="d-flex justify-content-center align-items-center" >
            <SupportLoader />
          </div>
        ) : (
          <>
            {props.clientName.length > 0 ? (
              props.nowCertQuoteData.length == 0 && props.isQuoteSelected ? (
                <p className="mt-5" style={{ color: "black", textAlign: "center", background: "#fff", padding: "5px 10px", borderRadius: "4px" }}>
                  Oops ! No quote found
                </p>
              ) : 
                props.isQuoteSelected?
                <>
                  <label htmlFor="client" className="form-label fw-medium text-14">
                    Select Existing Quote
                  </label>
                  <div className="row mt-2 " style={{ height: "30vh", overflowY: "auto" }}>
                    {props.nowCertQuoteData.map((quote: any) => (
                      <div className="col-md-6 col-lg-4 mb-3 show-cursor " onClick={() => props.onQuoteSelected(quote)}>
                        <div
                          className={
                            props.selectedQuoteId == quote.databaseId ? "card  shadow-sm transition bg-light border-purple" : "card border transition"
                          }
                        >
                          <div className="card-body text-12">
                            <h6 className="card-title mb-1 ">
                              {quote.linesOfBusiness[0]} - {quote.policyNumber}
                            </h6>
                            <p className="mb-1 text-muted">Premium: ${quote.totalPremium}</p>
                            <p className="mb-0 text-muted">
                              Date:{" "}
                              {quote.effectiveDate != null || quote.effectiveDate !== ""
                                ? moment.utc(quote.effectiveDate, "YYYY-MM-DD").format("MM/DD/YYYY")
                                : ""}{" "}
                            </p>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </>
                :
                null
              
            ) : null}
          </>
        )}
      </div>
    </div>
  );
}
